export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/appStoreIcon-140b25081ec967511f544b8b877e1373.svg";